<template>
  <div class="col-xl-12 bg-light textbox-grau">
    <h3> E-Mail-Adresse bestätigen</h3>
    <p class="copy_16">
      Ihnen wurde eine E-Mail mit einem Bestätigungslink an die E-Mail-Adresse
      <span class="copy_bold_16">{{ registrierungsdaten.emailAdresse }}</span> gesendet.
      Bitte klicken Sie auf den Link in der E-Mail,
      um den Registrierungsprozess zu vervollständigen.
    </p>
    <p class="copy_16">
      Ihre Registrierung wird im Anschluss in Ihrem Browser abgeschlossen.<br>
      Im Anschluss können Sie sich einfach in der App mit Ihren Logindaten anmelden.<br>
      Dieses Fenster kann nach Bestätigung Ihrer E-Mail-Adresse problemlos geschlossen werden.
    </p>
    <input type="button"
           id="email-btn"
           class="button-ivv white abstand-unten-17"
           :class="{'button-vgh': mandant === 1,
                  'button-oesa': mandant === 3,
                  'button-oevo': mandant === 5}"
           value="Zurück zur Startseite"
           @click="closeWindow"
    >
    <br />
    <br />
    <p class="copy_16">
      Sie haben keine E-Mail erhalten? <br>
      Bitte überprüfen Sie Ihre E-Mail-Adresse und senden sich erneut eine Bestätigungsmail.
    </p>
    <input type="button"
           id="email-btn"
           class="button-ivv abstand-unten-17"
           value="E-Mail erneut senden"
           @click="emailSenden"
    >
  </div>
</template>

<script>
import { mapState } from 'vuex';
import api from '@/backend-api';
import mandant from '@/mandant';

export default {
  name: 'EmailBestaetigung',
  mixins: [mandant],
  computed: {
    ...mapState(['registrierungsdaten']),
  },
  methods: {
    async emailSenden() {
      await api.sendeBestaetigungsEmail(
        this.$store.state.registrierungsdaten.emailAdresse,
      );
    },
    closeWindow() {
      let tenant = 'vgh';

      if (mandant === 3) {
        tenant = 'oesa';
      } else if (mandant === 5) {
        tenant = 'oevo';
      }

      const scheme = `de.${tenant}.kundenportal://`;
      window.location.href = scheme;
    },
  },
};
</script>
